export default __webpack_public_path__ + "static/pic10-a1ab14940546bba825ab1d86778e6369.jpg";